import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Component, inject, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { getPageTitle } from '@core/jss-routing';
import { getFieldValue, getItemLinkFieldValue } from '@core/jss-utils';
import type { IAccordionItems } from '@legacy/common-ui-utility-components';
import {
  IAccordion,
  AccordionComponent,
} from '@legacy/common-ui-utility-components';
import { select, Store } from '@ngrx/store';
import type { RichTextField } from '@sitecore-jss/sitecore-jss-angular';
import type { Item } from '@sitecore-jss/sitecore-jss/layout';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'wl-accordion-container',
  templateUrl: './accordion-container.component.html',
  styleUrls: ['./accordion-container.component.scss'],
  standalone: true,
  imports: [AccordionComponent, CSCaptureDirective, AsyncPipe],
})
export class LegacyMijnAccordionContainerComponent
  implements OnInit, OnChanges
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() accordions?: IAccordion;

  readonly #store$ = inject(Store<any>);
  readonly pageTitle$ = this.#store$.pipe(select(getPageTitle));

  ngOnInit() {
    this.accordions = this.renderingToModel(this.rendering);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.accordions = this.renderingToModel(this.rendering);
    }
  }

  public renderingToModel(
    rendering: InnogyComponentRendering | undefined
  ): IAccordion {
    if (rendering == null || rendering.fields == null) {
      return {};
    }

    const fields = rendering.fields;
    const itemFields = fields['items'] as Item[];

    const title = getFieldValue<string>(fields, 'title');

    const items = itemFields.map((item): IAccordionItems => {
      const question = item.fields['question'] as RichTextField;
      const answer = item.fields['answer'] as RichTextField;

      return {
        question,
        answer,
        id: `item-${this.hashCode(`${question.value} ${answer.value}`)}`,
      };
    });

    const cssClass = getItemLinkFieldValue(rendering.fields, 'class', '');
    return {
      id: rendering.uid,
      title,
      items,
      class: cssClass,
    };
  }

  private hashCode(str: string): number {
    if (str.length === 0) {
      return 0;
    }

    let hash = 0;

    for (let i = 0; i < str.length; i++) {
      const currentChar = str.charCodeAt(i);
      // eslint-disable-next-line no-bitwise
      hash = (hash << 5) - hash + currentChar;
    }

    return hash;
  }
}
